// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Buzs","textarea":"xEqQC","hasError":"xhk92","isResizable":"_1R_20"};